import React, { useEffect, useRef } from 'react';
import { useStore } from '@/store';
import { CameraControls } from './CameraControls';
import * as THREE from 'three';
import { cm } from '@/data/scales';

const Camera: React.FC = () => {
  const refControl = useRef<CameraControls>();
  const artId = useStore((state) => state.artId);
  const getArtNow = useStore((s) => s.getArtNow);
  const sortBy = useStore((s) => s.sortBy);

  const lookAtArtNow = () => {
    const artNow = getArtNow();
    const artMesh = artNow?.mesh;
    const artArea = artNow?.area ?? 0;
    const isBig = artArea >= 1000;
    const control = refControl.current;
    if (artMesh && control) {
      control.setLookAt(
        artMesh.position.x - cm(50),
        cm(isBig ? 100 : 40),
        cm(isBig ? 300 : 100),
        artMesh.position.x,
        artMesh.position.y,
        artMesh.position.z,
        true
      );
    }
  };

  useEffect(() => {
    lookAtArtNow();
  }, [artId]);

  useEffect(() => {
    setTimeout(() => {
      lookAtArtNow();
    }, 1000);
  }, [sortBy]);
  useEffect(() => {
    const control = refControl.current;
    if (control) {
      // default settings
      control.distance = 100;
      control.maxDistance = 130;
      control.minDistance = 50;
      // disable trucking/panning
      control.truckSpeed = 0;
      // control.setLookAt(-46.1, 29, 38.4);
      // for debugging
      // control.addEventListener('update', () => {
      //   console.log(control.camera.position);
      // });
      const camPos = new THREE.Vector3(-46.1, 29, 38.4);
      const defaultPos = new THREE.Vector3(32, 0, 0);
      control.setLookAt(
        camPos.x,
        camPos.y,
        camPos.z,
        defaultPos.x,
        defaultPos.y,
        defaultPos.z,
        false
      );
    }
  }, []);
  return <CameraControls ref={refControl as React.Ref<CameraControls>} />;
};

export default Camera;
